import request from "@/utils/request";

/** 获取玩家信息 **/
export function GetUserInfo (data) {
    return request({
        url: '/finance/info',
        method: 'post',
        data
    })
}

/** 获取充值记录 **/
export function GetPayInDetail (data) {
    return request({
        url: '/user/payInDetail',
        method: 'post',
        data
    })
}

/** 获取提现记录 **/
export function GetPayOutDetail (data) {
    return request({
        url: '/user/payOutDetail',
        method: 'post',
        data
    })
}

/** 获取游戏记录 **/
export function GetGameDetail (data) {
    return request({
        url: '/user/gameDetail',
        method: 'post',
        data
    })
}
